import * as React from 'react';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Box, TextField } from '@mui/material';
import { CONFIG } from "../../config";
import axios from "axios"
const API_HOST = CONFIG.modules["accounts"].host;

export default function PopoverSearch({title, onSelect, dataFromOzone}) {
  const [anchorEl, setAnchorEl] = React.useState(null);

    // searchInput, 
    const [search, setSearch] = React.useState("");

    // telecallers state
    const [telecallers, setTelecallers] = React.useState([]);

    // selected telecaller
    const [selectedTelecaller, setSelectedTelecaller] = React.useState(null);

    const inputChangeHandler = (e) => {

        const value = e.target.value;
        if(value.length === 0) {
            setSearch("");
            setTelecallers([]);
            return;
        }
        setSearch(value);
    }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getTelecallers = ()=>{
    axios.get(API_HOST + `/telecaller/search/${search}`).then((resp) => {
        if (resp.data && resp.data.success) {
            const newData = resp.data.telecallers
            console.log("new user search data",newData);
            setTelecallers([...newData])
        }
    }).catch((e) => {
        console.log(e)
    })
  }

  React.useEffect(() => {
    const timeoutId = setTimeout(()=>{
        if(search.length === 0) return;
        getTelecallers();
      }, 500)
      return ()=>{
        clearTimeout(timeoutId)
      }
  },[search])

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <Button aria-describedby={id} variant="outlined" onClick={handleClick}
      disabled={!dataFromOzone}
      >
        {title}
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
      >
        {/* Container of width: 30rem and height 40rem */}
        <Box sx={{
            minWidth: "25rem",
            maxWidth: "25rem",
            maxHeight: "30rem",
            // backgroundColor: "green",
            padding: "1rem",
            overflowY: "auto"
        }}> 
            {/* Search bar */}
            <TextField 
            value={search}
            fullWidth label="Search Telecaller" id="fullWidth" onChange={inputChangeHandler} />
            {/* end search bar */}

            {/* List of telecaller */}
            <Box>
                {telecallers.map(telecaller => {
                    return <Box sx={{
                        padding: "0.3rem",
                        borderStyle: "solid",
                        borderWidth: "0.1rem",
                        borderRadius:"0.4rem",
                        borderWidth: "0.1rem",
                        padding:"0.4rem",
                        marginTop:"0.2rem",
                        marginBottom:"0.2rem",
                        cursor:"pointer"
                    }}
                    onClick={() => {
                        onSelect(telecaller)
                        handleClose();
                    }}
                    >
                        {telecaller.name}
                    </Box>
                })}
            </Box>
            {/* end list of telecaller */}
        </Box>
      </Popover>
    </div>
  );
}